export default "__VITE_ASSET__BFCnEOu8__"